var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from "@emotion/css";
import { scrollToElement } from "../../plugins/helpers/scrollToElement";
var AnchorItem = function (_a) {
    var targetId = _a.targetId, name = _a.name, type = _a.type;
    return (_jsx("li", __assign({ className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        border-radius: 9px;\n        transition: all 0.3s;\n        list-style: none;\n        padding: 5px;\n        padding-left: ", ";\n        text-decoration: none;\n        font-size: 20px;\n        line-height: 24px;\n        font-weight: bold;\n        cursor: pointer;\n        color: ", ";\n      "], ["\n        border-radius: 9px;\n        transition: all 0.3s;\n        list-style: none;\n        padding: 5px;\n        padding-left: ", ";\n        text-decoration: none;\n        font-size: 20px;\n        line-height: 24px;\n        font-weight: bold;\n        cursor: pointer;\n        color: ", ";\n      "])), type === "heading-one" ? "5px" : "15px  ", type === "heading-one" ? "#000" : "rgb(83, 81, 80)"), onClick: function () {
            scrollToElement(targetId);
        } }, { children: _jsx("div", __assign({ className: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        "], ["\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        "]))) }, { children: name })) })));
};
export default AnchorItem;
var templateObject_1, templateObject_2;
